import Accordion from '@/components/sections/Accordion'
import Blocks from '@/components/sections/Blocks'
import CasiBlock from '@/components/sections/CasiBlock'
import ContactForm from '@/components/sections/ContactForm'
import DoubleBlock from '@/components/sections/DoubleBlock'
import Gallery from '@/components/sections/Gallery'
import Hero from '@/components/sections/Hero'
import HeroHome from '@/components/sections/HeroHome'
import Media from '@/components/sections/Media'
import OnlyText from '@/components/sections/OnlyText'
import ProfessionistiBlock from '@/components/sections/ProfessionistiBlock'
import Spacer from '@/components/sections/Spacer'

export const sectionsMap: any = {
  blocks: Blocks,
  double_block: DoubleBlock,
  only_text: OnlyText,
  accordion: Accordion,
  hero: Hero,
  hero_home: HeroHome,
  media: Media,
  gallery: Gallery,
  spacer: Spacer,
  form: ContactForm,
  casi_block: CasiBlock,
  professionisti_block: ProfessionistiBlock
}
